import type { ExportsXmpMetadata } from '@frameio/graphql-client/generated';
import { useShareForSequenceShareFragment } from '../gql';

export const useGetAssetIdForSequenceExport = (
  exportData: ExportsXmpMetadata | null
) => {
  let assetId = '';
  if (exportData && 'assetId' in exportData) {
    assetId = exportData.assetId;
  }

  const shareId =
    exportData && 'shareId' in exportData ? exportData.shareId : null;

  const { data } = useShareForSequenceShareFragment({
    from: shareId ? { __typename: 'Share', id: shareId } : null,
  });

  if (!assetId && 'assets' in data) {
    assetId = data?.assets?.nodes?.[0]?.id ?? '';
  }

  return assetId;
};
